/**
 * Strip colour convention for the stripboard (M2.1). Pure — mirrors
 * backend/services/stripboard.py so the board, the PDF and the DOOD agree:
 *   white = INT/day · yellow = EXT/day · blue = INT/night · green = EXT/night
 */
export const STRIP_KEYS = ['white', 'yellow', 'blue', 'green', 'neutral'];

const DAYISH = new Set(['day', 'morning', 'afternoon']);
const NIGHTISH = new Set(['night', 'evening']);

export function stripKey(scene) {
  if (scene?.strip && STRIP_KEYS.includes(scene.strip)) return scene.strip;
  const ie = scene?.interior_exterior;
  const t = String(scene?.time_of_day || '').toLowerCase();
  const night = NIGHTISH.has(t);
  const day = DAYISH.has(t);
  if (!(night || day) || !(ie === 'interior' || ie === 'exterior')) return 'neutral';
  if (ie === 'interior') return night ? 'blue' : 'white';
  return night ? 'green' : 'yellow';
}
